'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactRedux = require('react-redux');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

var _actions = require('../../actions');

var actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(_ref) {
	var companyProfile = _ref.companyProfile;
	return {
		name: companyProfile.name,
		website: companyProfile.website,
		location: companyProfile.location,
		avatar: companyProfile.avatar,
		yearFounded: companyProfile.yearFounded,
		createdOn: companyProfile.createdOn,
		employees: companyProfile.employees,
		overview: companyProfile.overview,
		followedByUser: companyProfile.followedByUser,
		followedByUserRequested: companyProfile.followedByUserRequested,
		followedByUserRequestError: companyProfile.followedByUserRequestError,
		blockedByUser: companyProfile.blockedByUser,
		blockCompanyRequested: companyProfile.blockCompanyRequested,
		blockCompanyRequestError: companyProfile.blockCompanyRequestError
	};
};

var mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
	var followedByUser = stateProps.followedByUser;
	var dispatch = dispatchProps.dispatch;
	var csrf = ownProps.csrf,
	    companyNumber = ownProps.companyNumber;


	return _extends({}, stateProps, ownProps, {
		toggleFollowCompany: function toggleFollowCompany() {
			return dispatch(actions.toggleFollowCompany(companyNumber, csrf, followedByUser));
		},
		blockFunc: function blockFunc() {
			return dispatch(actions.blockCompany(companyNumber, csrf));
		}
	});
};

var _default = (0, _reactRedux.connect)(mapStateToProps, null, mergeProps)(_template2.default);

exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'src/components/WMCompanyPageOverview/index.js');

	__REACT_HOT_LOADER__.register(mergeProps, 'mergeProps', 'src/components/WMCompanyPageOverview/index.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/WMCompanyPageOverview/index.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/@workmarket/wm-company-pages-spa/build/components/WMCompanyPageOverview/index.js
// module id = hCZN
// module chunks = 62 63